import { MenuItemOption, type MenuItemOptionProps } from '@chakra-ui/react';

export type UiMenuItemOptionProps = MenuItemOptionProps;

export const UiMenuItemOption = MenuItemOption;
